import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CenterIcon from "../../../components/ui/CenterIcon";
import ExamContext from "../../../context/ExamContext";
import { baseURL } from "../../../config";
import modal from "../../../services/modalServices";
import LoadingIcon from "../../../components/ui/LoadingIcon";
import { printUnit } from "../../../utils/ar";
import InputField from "../../../components/form/elements/InputField";
import { handleInputChange } from "../../../services/formServices";
import AudioPlayer from "../../../components/ui/AudioPlayer";
import { useLanguage } from "../../../context/LanguageContext";

const Question = () => {
    const { question_id } = useParams();
    const {
        questions,
        setQuestions,
        startExam,
        setStartExam,
        forwardedToExam,
        triggerSaving,
        exam,
    } = useContext(ExamContext);
    const { language } = useLanguage();
    const [isAudioLoading, setIsAudioLoading] = useState(true);

    const [question, setQuestion] = useState(false);

    const [selectedAnswer, setSelectedAnswer] = useState("");
    const [placeHolder, setPlaceHolder] = useState("");

    const [isDisabled, setIsDisabled] = useState(false);

    const [timer, setTimer] = useState(0);

    const navigate = useNavigate();

    const [data, setData] = useState({
        your_answer: "",
    });

    useEffect(() => {
        if (!forwardedToExam) {
            navigate("../", { replace: true });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forwardedToExam]);

    useEffect(() => {
        if (forwardedToExam && questions.length > 0) {
            const toSetQuestion = questions[question_id];
            toSetQuestion["opened"] = true;
            setQuestion(toSetQuestion);
            setSelectedAnswer(toSetQuestion.selected_answer);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questions, startExam]);

    useEffect(() => {
        if (forwardedToExam && question) {
            const currentQuestions = questions;
            setQuestions([]);
            currentQuestions[question_id] = question;
            setQuestions(currentQuestions);
            // setTimeout(() => {
            //     currentQuestions[question_id] = question;
            //     setQuestions(currentQuestions);
            // }, 50);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [question]);

    useEffect(() => {
        const timeIntVal = setInterval(() => {
            const now = new Date().getTime();
            if (now - timer > 500) {
                setIsDisabled(false);
                clearInterval(timeIntVal);
            }
        }, 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triggerSaving]);

    useEffect(() => {
        if (forwardedToExam && !startExam) {
            modal.message({
                icon: "",
                title: "بدأ الامتحان الآن !",
                text:
                    exam.sectionable_id === 101
                        ? `تنبيه هام:
                خلّ بالك يا صديقي: الامتحان هيتفتح مرة واحدة بس، ولك محاولة مرة واحدة بس … آخد بالك: مرة وااااااحدة بسسسسسسسس`
                        : "",
                buttons: {
                    confirm: "بدأ الامتحان",
                    cancel: "إلغاء",
                },
                callback: (e) => {
                    if (e && e !== "cancel") {
                        navigate("../questions/0");
                        window.scrollTo(0, 0);
                        setStartExam(true);
                    } else {
                        navigate("../", { replace: true });
                    }
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startExam]);

    const handleChange = ({ currentTarget }) => {
        setIsDisabled(true);
        setTimer(new Date().getTime());
        setSelectedAnswer(currentTarget.value);

        const currentQuestions = questions;
        setQuestions([]);
        currentQuestions[question_id] = { ...question, selected_answer: currentTarget.value };
        setTimeout(() => {
            setQuestions(currentQuestions);
        }, []);
    };
    const handleSaveAnswer = () => {
        console.log("saved");
        setIsDisabled(true);
        const currentQuestions = questions;
        setQuestions([]);
        currentQuestions[question_id] = { ...question, selected_answer: data.your_answer };
        setTimeout(() => {
            setQuestions(currentQuestions);
        }, []);
    };
    // useEffect(() => {
    //     return () => {
    //         if (question.question_type === "essay") {
    //             // console.log(data);
    //         }
    //     };
    // }, [question]);
    useEffect(() => {
        if (question.question_type === "essay") {
            setData({
                your_answer: question.selected_answer,
            });
        }
    }, [question]);
    return (
        <>
            {startExam && question ? (
                <div className="rounded-md shadow-lg p-10 space-y-6">
                    {question.partition_type === "segment" && (
                        <div className="border-l-4 en border-[#FF640D] bg-[#FFF6EC] dark:bg-[#450F05] p-4 rounded-md shadow-lg">
                            {/* 📌 Segment Title */}
                            <h2 className="text-base md:text-xl font-bold text-[#CC3405] dark:text-[#FFD700]">
                                {question.segment_title}
                            </h2>

                            {/* 🎙 Voice Segment (Audio) */}
                            {question.audio_source && (
                                <div className="px-2 mt-2">
                                    <div className="w-full rounded-md bg-[#FFD2A7] dark:bg-[#80250E] p-3 flex items-center justify-between shadow">
                                        {isAudioLoading && (
                                            <div className="flex items-center justify-center w-full h-full">
                                                <LoadingIcon className="text-[#FF640D]" />
                                            </div>
                                        )}
                                        <AudioPlayer
                                            isDeletingAllowed={false}
                                            audioSrc={`${baseURL}/${question.audio_source}`}
                                            onLoadedData={() => setIsAudioLoading(false)}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* 🖼️ Display Image if Available */}
                            {question.segment_picture && (
                                <div className="mt-4 flex justify-center">
                                    <img
                                        src={`${baseURL}/${question.segment_picture}`}
                                        alt="Segment Illustration"
                                        className="w-full sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl rounded-lg shadow-md"
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    <div className="flex-center-both en">
                        <div className="rounded-full bg-yellow-500 text-white px-10 py-1">
                            {printUnit(question.score, "درجة", language)}
                        </div>
                    </div>
                    <div className="font-h2 en font-w-bold flex space-x-2 ">
                        <CenterIcon
                            className="text-blue-400 font-h1"
                            icon={"line-md:question-circle-twotone"}
                        />
                        <div>{question["title"]}</div>
                    </div>
                    <div className="px-2 en space-y-5 sm:space-y-0 flex sm:flex-row flex-col space-x-2 ">
                        <div
                            className={`${
                                question.picture ? "sm:basis-1/2 basis-full" : ""
                            } w-full space-y-1`}
                        >
                            <div
                                className={` flex font-h1 pb-1 -mt-4 text-blue-500 -mr-2 ${
                                    isDisabled ? "" : "opacity-0"
                                }`}
                            >
                                <LoadingIcon />
                            </div>
                            {question.question_type === "mcq" ? (
                                <>
                                    {[
                                        question.answer_1,
                                        question.answer_2,
                                        question.answer_3,
                                        question.answer_4,
                                    ]
                                        .filter((answer) => answer !== null && answer !== "")
                                        .map((answer, index) => (
                                            <div
                                                key={index}
                                                className="answer_group flex space-x-2"
                                            >
                                                <div className="flex-center-both">
                                                    <input
                                                        disabled={isDisabled}
                                                        name={`question_${question.id}`}
                                                        onChange={handleChange}
                                                        checked={selectedAnswer === answer}
                                                        type="radio"
                                                        value={answer}
                                                    />
                                                </div>
                                                <div>{answer}</div>
                                            </div>
                                        ))}
                                </>
                            ) : (
                                <InputField
                                    id="your_answer"
                                    type="textarea"
                                    placeholder="اجابتك"
                                    setData={setData}
                                    data={data}
                                    isDisabled={isDisabled}
                                    onBlur={handleSaveAnswer}
                                    onChange={handleInputChange}
                                />
                            )}
                        </div>
                        {question.picture ? (
                            <div className="sm:basis-1/2 basis-full w-full">
                                <img
                                    src={`${baseURL}/${question.picture}`}
                                    alt="question"
                                    className="w-full"
                                />
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            ) : (
                placeHolder
            )}
        </>
    );
};

export default Question;
